<script>
export default {
  name: 'DuButton',

  props: {
    type: { type: String, default: 'primary' },
    nativeType: { type: String, default: 'button' },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick(evt) {
      this.$emit('click', evt)
    }
  },

  render() {
    return (
      <button
        onClick={this.handleClick}
        disabled={this.disabled}
        type={this.nativeType}
        class={[
          'du-button',
          this.type && `du-button--${this.type}`,
          { 'du-button--disabled': this.disabled }
        ]}
      >
        {this.$slots.default ? <span>{this.$slots.default}</span> : ''}
      </button>
    )
  }
}
</script>

<style lang="sass" scoped>
.du-button
  display: block
  width: 100%
  height: 88px
  padding: 0
  margin: 0
  text-align: center
  white-space: nowrap
  cursor: pointer
  font-size: 32px
  line-height: 1
  color: #fff
  background-color: #00cbcc
  outline: none
  border: none
  border-radius: 2px
  box-sizing: border-box
  -webkit-tap-highlight-color: transparent
  &--default
    color: rgb(20, 21, 26)
    background-color: rgb(255, 255, 255)
    border: 0.5px solid rgb(199, 199, 215)
  &--disabled
      opacity: 0.3
  &--primary-black
    color: #FFF
    background-color: #14151A
  &--default-new
    color: #14151A
    background-color: #FFF
    border: 0.5px solid #14151A
</style>
